import { InputTitle } from 'components/input/InputTitle';
import { Button, Spacing, TextInput, Typography } from 'enable-ui';

import { useCreatePasswordController } from '../core';

export const CreatePasswordPage = () => {
  const {
    password,
    confirmedPassword,
    passwordStatus,
    confirmedPasswordStatus,
    handleChange,
    handleSubmit,
    disabled,
  } = useCreatePasswordController();

  return (
    <div>
      <Spacing spacing="4xl" placement="bottom" type="margin" style={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          weight={500}
          style={{
            fontSize: '26px',
            lineHeight: '36px',
            marginBottom: 12,
          }}
        >
          Set new password
        </Typography>
        <Typography style={{ fontSize: '18px', lineHeight: '26px' }}>
          Please note that this password will be be used to login to both web and mobile app.
        </Typography>
      </Spacing>
      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="Your new password" style={{ color: '#222222' }} />
        <TextInput
          name="password"
          type="password"
          value={password}
          onChange={handleChange}
          helperText={passwordStatus.helperText}
          color={passwordStatus.color}
          containerStyle={{
            maxWidth: 'auto',
          }}
        />
      </Spacing>

      <Spacing spacing="4xl" placement="bottom" type="margin">
        <InputTitle title="Re-enter password" style={{ color: '#222222' }} />
        <TextInput
          name="confirmedPassword"
          type="password"
          value={confirmedPassword}
          onChange={handleChange}
          helperText={confirmedPasswordStatus.helperText}
          color={confirmedPasswordStatus.color}
          containerStyle={{
            maxWidth: 'auto',
          }}
        />
      </Spacing>

      <Button
        variant="contained"
        color="primary"
        type="submit"
        size="large"
        style={{
          width: '100%',
          fontSize: '18px',
          lineHeight: '26px',
          fontWeight: 600,
        }}
        disabled={disabled}
        onClick={() => handleSubmit()}
      >
        Save password
      </Button>
    </div>
  );
};
